import { memo, useMemo } from 'react';

import { Scrollbars } from 'react-custom-scrollbars-2';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useSelector } from 'react-redux';

import { cn } from '@/lib/utils';
import { EXTENSIONS, OPERATIONS, RESPONSES, START_WITH, SUBAGENTS } from '@/redux/dialogs/helper';
import { selectFeatureFlags } from '@/redux/featureFlag/selectors';
import { RootState } from '@/shared/types/state';

import ToolkitList from './ToolkitList';

import styles from './Toolkit.module.scss';

const ToolkitMenu = () => {
  const { t } = useTranslation();
  const hasNodes = useSelector((state: RootState) => state.nodes.nodes.length > 0, shallowEqual);

  // Hidden until its flag is on; an action already in a dialog still renders and saves.
  const { switch_channels, question_set } = useSelector(selectFeatureFlags);
  const availableResponses = RESPONSES.filter(
    ({ id }) => id !== 'replay' && (question_set || id !== 'question_set')
  );
  const operations = switch_channels
    ? OPERATIONS
    : OPERATIONS.filter(({ id }) => id !== 'switch_channel');

  const starters = useMemo(
    () => START_WITH.filter(({ id }) => !(id === 'unknown' && !hasNodes)),
    [hasNodes]
  );

  return (
    <Scrollbars style={{ width: 360 }}>
      <div className={cn(styles.toolkit)}>
        <span
          className={cn('text-sm leading-5 font-semibold text-foreground-muted', styles.header)}
        >
          {t('dialog.toolkit')}
        </span>
        <ToolkitList items={starters} t={t} title="trigger" />
        {hasNodes && (
          <>
            <ToolkitList items={availableResponses} t={t} title="respond_with" />
            <ToolkitList items={operations} t={t} title="operations" />
            <ToolkitList items={SUBAGENTS} t={t} title="subagents" />
            <ToolkitList items={EXTENSIONS} t={t} title="extensions" />
          </>
        )}
      </div>
    </Scrollbars>
  );
};

export default memo(ToolkitMenu);
